import { PropsWithChildren, useRef, useState } from "react";
import { FieldValues, FieldPath } from "react-hook-form";
import { FormFieldProps } from "@/types/common";
import { ImageCrop } from "../Elements/Image";

export const UploadImageField = <
  TFormValues extends FieldValues,
  TFieldName extends FieldPath<TFormValues>
>({
  children,
  setValue,
  name,
}: PropsWithChildren<FormFieldProps<TFormValues, TFieldName>>) => {
  const [imgSrc, setImgSrc] = useState<string>();
  const hiddenInputRef = useRef<HTMLInputElement>(null);

  function onSelectFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        const fileUrl = reader.result?.toString().split(",");
        if (fileUrl && fileUrl.length > 1) {
          onImageCropped({
            fileDataAsBase64: fileUrl[1],
            fileName: `cropped_${Date.parse(new Date().toString())}.jpg`,
          });
        }
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  const handleAddPhoto = () => {
    hiddenInputRef.current?.click();
  };

  const onImageCropped = (value: any) => {
    setValue(name, value);
    setImgSrc(undefined);
  };

  return (
    <>
      <input
        type="file"
        accept="image/*"
        className="hidden"
        ref={hiddenInputRef}
        onChange={onSelectFile}
      />
      <ImageCrop imgSrc={imgSrc} onImageCropped={onImageCropped} />
      <div onClick={handleAddPhoto} className="cursor-pointer">
        {children}
      </div>
    </>
  );
};
